import React from 'react'
import { Table } from 'react-bootstrap'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { formatTimeString } from '../../utils/formatters'
import StatusLabel from './status_label'
import { ACCREDITATION_GRID_SORT_UPDATED } from '../../actions/accreditation_grid_sort'

const AccreditationStatusTable = ({ results, handleTableSort, navigateToIdentity }) => (
  <Table striped bordered hover>
    <thead>
      <tr>
        <th>ID</th>
        <th>Status</th>
        <th>Identity</th>
        <th>Message</th>
        <th className='cursor-pointer' onClick={() => handleTableSort(ACCREDITATION_GRID_SORT_UPDATED)}>
          Updated
        </th>
      </tr>
    </thead>
    <tbody>
      {results &&
        results.map((accreditationStatus) =>
          results ? (
            <tr key={accreditationStatus.id}>
              <td>
                {accreditationStatus.id && accreditationStatus.id.split('-')[0]}
                {'... '}
                <CopyToClipboard text={accreditationStatus.id}>
                  <span className='cursor-pointer'>
                    <i className='fa fa-copy' title='Click to Copy ID' />
                  </span>
                </CopyToClipboard>
              </td>
              <td>
                <StatusLabel status={accreditationStatus.status} />
              </td>
              <td
                className='cursor-pointer'
                onClick={() => {
                  navigateToIdentity(accreditationStatus.identity.transaction)
                }}
              >
                {accreditationStatus.identity.first_name} {accreditationStatus.identity.last_name}
              </td>
              <td>{accreditationStatus.message}</td>
              <td>{formatTimeString(accreditationStatus.updated)}</td>
            </tr>
          ) : (
            <tr key={accreditationStatus.id}>
              <td>-</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
            </tr>
          )
        )}
    </tbody>
  </Table>
)

export default AccreditationStatusTable
